module.exports = __webpack_public_path__ + "static/cad-designs6-4da6633abaadbe67095f162ec9b7bd66.png";